export default __webpack_public_path__ + "static/media/adegbola.f3b799ff.png";